import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601 date string, e.g. `2013-12-01T10:00:00.000Z`. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Query = {
  __typename?: 'Query';
  staffCategories: StaffCategories;
  calculationParameters: CalculationParameters;
  vehicles: Vehicles;
  contractors: Array<Contractor>;
  contractor?: Maybe<Contractor>;
  invoiceItems: Array<InvoiceItem>;
  moves?: Maybe<Array<Maybe<Move>>>;
  move?: Maybe<SynchronizedMove>;
  packingMaterials: Array<PackingMaterial>;
  packingMaterial?: Maybe<PackingMaterial>;
  rooms: Array<Room>;
  room?: Maybe<Room>;
  templates: Array<Template>;
  users: Array<User>;
  user?: Maybe<User>;
};


export type QueryContractorArgs = {
  id: Scalars['ID'];
};


export type QueryMoveArgs = {
  id: Scalars['ID'];
};


export type QueryPackingMaterialArgs = {
  id: Scalars['ID'];
};


export type QueryRoomArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  updateStaffCategories: StaffCategories;
  updateCalculationParameters: CalculationParameters;
  updateVehicles: Vehicles;
  createContractor: Contractor;
  updateContractor?: Maybe<Contractor>;
  removeContractor?: Maybe<Contractor>;
  createInvoiceItem: InvoiceItem;
  updateInvoiceItem?: Maybe<InvoiceItem>;
  removeInvoiceItem?: Maybe<InvoiceItem>;
  createMove?: Maybe<SynchronizedMove>;
  synchronizeMove?: Maybe<SynchronizedMove>;
  createPackingMaterial: PackingMaterial;
  updatePackingMaterial?: Maybe<PackingMaterial>;
  removePackingMaterial?: Maybe<PackingMaterial>;
  updatePackingMaterialOrder: Array<PackingMaterial>;
  createRoom: Room;
  updateRoom?: Maybe<Room>;
  removeRoom?: Maybe<Room>;
  uploadTemplate: Template;
  createUser: User;
  updateUser?: Maybe<User>;
  removeUser?: Maybe<User>;
};


export type MutationUpdateStaffCategoriesArgs = {
  staffCategories: StaffCategoriesInput;
};


export type MutationUpdateCalculationParametersArgs = {
  calculationParameters: CalculationParametersInput;
};


export type MutationUpdateVehiclesArgs = {
  vehicles: VehiclesInput;
};


export type MutationCreateContractorArgs = {
  contractor: ContractorInput;
};


export type MutationUpdateContractorArgs = {
  id: Scalars['ID'];
  contractor: ContractorInput;
};


export type MutationRemoveContractorArgs = {
  id: Scalars['ID'];
};


export type MutationCreateInvoiceItemArgs = {
  invoiceItem: InvoiceItemInput;
};


export type MutationUpdateInvoiceItemArgs = {
  id: Scalars['ID'];
  invoiceItem: InvoiceItemInput;
};


export type MutationRemoveInvoiceItemArgs = {
  id: Scalars['ID'];
};


export type MutationCreateMoveArgs = {
  move?: Maybe<Scalars['JSONObject']>;
};


export type MutationSynchronizeMoveArgs = {
  id: Scalars['ID'];
  actions: Array<Scalars['JSONObject']>;
};


export type MutationCreatePackingMaterialArgs = {
  packingMaterial: PackingMaterialInput;
};


export type MutationUpdatePackingMaterialArgs = {
  id: Scalars['ID'];
  packingMaterial: PackingMaterialInput;
};


export type MutationRemovePackingMaterialArgs = {
  id: Scalars['ID'];
};


export type MutationUpdatePackingMaterialOrderArgs = {
  order: Array<Scalars['ID']>;
};


export type MutationCreateRoomArgs = {
  room: RoomInput;
};


export type MutationUpdateRoomArgs = {
  id: Scalars['ID'];
  room: RoomInput;
};


export type MutationRemoveRoomArgs = {
  id: Scalars['ID'];
};


export type MutationUploadTemplateArgs = {
  templateType: TemplateType;
  template: Scalars['Upload'];
};


export type MutationCreateUserArgs = {
  user: CreateUserInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  user: UpdateUserInput;
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID'];
};

export type StaffCategories = {
  __typename?: 'StaffCategories';
  /** Umzugsberater */
  consultant: StaffCategory;
  /** Teamleiter/Kolonnenführer */
  teamLeader: StaffCategory;
  /** Träger */
  carrier: StaffCategory;
  /** Azubi */
  trainee: StaffCategory;
  /** Aushilfe */
  temporaryEmployee: StaffCategory;
  /** Glaspacker */
  glassPacker: StaffCategory;
};

export type StaffCategory = {
  __typename?: 'StaffCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  dailyRate?: Maybe<Scalars['Float']>;
  hourlyRate: Scalars['Float'];
};

export type StaffCategoriesInput = {
  /** Umzugsberater */
  consultant?: Maybe<StaffCategoryInput>;
  /** Teamleiter/Kolonnenführer */
  teamLeader?: Maybe<StaffCategoryInput>;
  /** Träger */
  carrier?: Maybe<StaffCategoryInput>;
  /** Azubi */
  trainee?: Maybe<StaffCategoryInput>;
  /** Aushilfe */
  temporaryEmployee?: Maybe<StaffCategoryInput>;
  /** Glaspacker */
  glassPacker?: Maybe<StaffCategoryInput>;
};

export type StaffCategoryInput = {
  dailyRate?: Maybe<Scalars['Float']>;
  hourlyRate: Scalars['Float'];
};

export type CalculationParameters = {
  __typename?: 'CalculationParameters';
  /** Lagermiete pro Monat und m³ */
  storageRent: Scalars['Float'];
  /** Containermiete pro Tag */
  containerRent: Scalars['Float'];
  /** Containerhandling pro Stück */
  containerHandling: Scalars['Float'];
  /** An- und Abfahrt Container */
  containerTransport: Scalars['Float'];
  /** Halteverbotszone einrichten (Pauschale) */
  noParkingZone: Scalars['Float'];
  /** Entsorgung Sperrmüll pro Tonne */
  bulkyWasteDisposal: Scalars['Float'];
  /** Kilometersatz Anlieferung Packmaterial */
  kilometerRatePackingMaterial: Scalars['Float'];
  /** Schwellwert (RE), unter dem nur der Möbelwagen eingesetzt wird */
  trailerThreshold: Scalars['Float'];
  /** Faktor für den Preis der Versicherung (Anteil des Neuwerts) */
  insuranceFactor: Scalars['Float'];
  /** Mindestpreis der Versicherung */
  insuranceMinimum: Scalars['Float'];
  /** LKW-Maut */
  truckToll?: Maybe<Scalars['Float']>;
  /** LKW-Maut mit Anhänger */
  truckTollWithTrailer?: Maybe<Scalars['Float']>;
};

export type CalculationParametersInput = {
  /** Lagermiete pro Monat und m³ */
  storageRent?: Maybe<Scalars['Float']>;
  /** Containermiete pro Tag */
  containerRent?: Maybe<Scalars['Float']>;
  /** Containerhandling pro Stück */
  containerHandling?: Maybe<Scalars['Float']>;
  /** An- und Abfahrt Container */
  containerTransport?: Maybe<Scalars['Float']>;
  /** Halteverbotszone einrichten (Pauschale) */
  noParkingZone?: Maybe<Scalars['Float']>;
  /** Entsorgung Sperrmüll pro Tonne */
  bulkyWasteDisposal?: Maybe<Scalars['Float']>;
  /** Kilometersatz Anlieferung Packmaterial */
  kilometerRatePackingMaterial?: Maybe<Scalars['Float']>;
  /** Schwellwert (RE), unter dem nur der Möbelwagen eingesetzt wird */
  trailerThreshold?: Maybe<Scalars['Float']>;
  /** Faktor für den Preis der Versicherung (Anteil des Neuwerts) */
  insuranceFactor?: Maybe<Scalars['Float']>;
  /** Mindestpreis der Versicherung */
  insuranceMinimum?: Maybe<Scalars['Float']>;
  /** LKW-Maut */
  truckToll?: Maybe<Scalars['Float']>;
  /** LKW-Maut mit Anhänger */
  truckTollWithTrailer?: Maybe<Scalars['Float']>;
};

export type Vehicles = {
  __typename?: 'Vehicles';
  /** PKW Berater */
  consultantCar: Vehicle;
  /** Möbelwagen (FV-NV alt) */
  furnitureTruck: Vehicle;
  /** Anhänger für Möbeltransport (EW 410) */
  trailer: Vehicle;
  /** Zusätzliches Fahrzeug für Personal (EW 310) */
  staffCar: Vehicle;
  /** Fahrzeug/Anhänger für Außenaufzug (EW 481) */
  lift: Vehicle;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID'];
  dailyRate?: Maybe<Scalars['Float']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  kilometerRate?: Maybe<Scalars['Float']>;
};

export type VehiclesInput = {
  /** PKW Berater */
  consultantCar?: Maybe<VehicleInput>;
  /** Möbelwagen (FV-NV alt) */
  furnitureTruck?: Maybe<VehicleInput>;
  /** Anhänger für Möbeltransport (EW 410) */
  trailer?: Maybe<VehicleInput>;
  /** Zusätzliches Fahrzeug für Personal (EW 310) */
  staffCar?: Maybe<VehicleInput>;
  /** Fahrzeug/Anhänger für Außenaufzug (EW 481) */
  lift?: Maybe<VehicleInput>;
};

export type VehicleInput = {
  dailyRate?: Maybe<Scalars['Float']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  kilometerRate?: Maybe<Scalars['Float']>;
};

export type Contractor = {
  __typename?: 'Contractor';
  id: Scalars['ID'];
  name: Scalars['String'];
  travelCost: Scalars['Float'];
  travelCostType: TravelCostCalculation;
  hourlyRate?: Maybe<Scalars['Float']>;
  workType: ContractorWorkType;
};

export type ContractorInput = {
  name: Scalars['String'];
  travelCost: Scalars['Float'];
  travelCostType: TravelCostCalculation;
  hourlyRate?: Maybe<Scalars['Float']>;
  workType: ContractorWorkType;
};

export enum TravelCostCalculation {
  /** Anfahrt wird pro Kilometer berechnet */
  PerKilometer = 'perKilometer',
  /** Pauschale Anfahrtkosten pro Arbeitskraft */
  FixedPerEmployee = 'fixedPerEmployee'
}

export enum ContractorWorkType {
  /** Träger, werden mit den eigenen Trägern verrechnet */
  Carrier = 'carrier',
  /** Montage (Tischler), wird separat aufgeführt */
  Assembly = 'assembly',
  /**
   * Sonstiges
   * Firmen, die diese Leistung anbieten, werden separat aufgeführt und die Kosten
   * werden pauschal angegeben durch den Umzugsberater
   */
  Other = 'other'
}

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  unit?: Maybe<InvoiceItemUnit>;
};

export type InvoiceItemInput = {
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  unit?: Maybe<InvoiceItemUnit>;
};

export enum InvoiceItemUnit {
  Kilogram = 'kilogram',
  Meter = 'meter',
  Piece = 'piece',
  Ton = 'ton',
  Hour = 'hour'
}

export type SynchronizedMove = {
  __typename?: 'SynchronizedMove';
  id: Scalars['ID'];
  updatedAt: Scalars['Date'];
  data: Scalars['JSONObject'];
};

export type Move = {
  __typename?: 'Move';
  id: Scalars['ID'];
  customer: MoveCustomer;
  loadingAddresses: Array<Address>;
  unloadingAddresses: Array<Address>;
  updatedAt: Scalars['Date'];
};

export type MoveCustomer = {
  __typename?: 'MoveCustomer';
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
};

export type PackingMaterial = {
  __typename?: 'PackingMaterial';
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  unit: PackingMaterialUnit;
};

export enum PackingMaterialUnit {
  Piece = 'piece',
  Kilogram = 'kilogram',
  Meter = 'meter'
}

export type PackingMaterialInput = {
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  unit: PackingMaterialUnit;
};

export type Room = {
  __typename?: 'Room';
  id: Scalars['ID'];
  name: Scalars['String'];
  items: Array<RoomItem>;
};

export type RoomItem = {
  __typename?: 'RoomItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  size: Scalars['Float'];
  assemblyTime?: Maybe<Scalars['Float']>;
  disassemblyTime?: Maybe<Scalars['Float']>;
  packingMaterial: Array<RoomItemPackingMaterial>;
};

export type RoomItemPackingMaterial = {
  __typename?: 'RoomItemPackingMaterial';
  amount: Scalars['Float'];
  type: PackingMaterial;
  inAdvance: Scalars['Boolean'];
};

export type RoomInput = {
  name: Scalars['String'];
  items: Array<RoomItemInput>;
};

export type RoomItemInput = {
  /**
   * ID of an existing item to update it instead of creating a new item.
   * Must be (at least) unique per room.
   */
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  size: Scalars['Float'];
  assemblyTime?: Maybe<Scalars['Float']>;
  disassemblyTime?: Maybe<Scalars['Float']>;
  packingMaterial: Array<RoomItemPackingMaterialInput>;
};

export type RoomItemPackingMaterialInput = {
  /** ID of a PackingMaterial object */
  type: Scalars['ID'];
  amount: Scalars['Float'];
  /** Whether this packing material should be delivered in advance */
  inAdvance: Scalars['Boolean'];
};


export type Template = {
  __typename?: 'Template';
  id: Scalars['ID'];
  type: TemplateType;
  version: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum TemplateType {
  /** Anschreiben Angebot */
  OfferLetter = 'offerLetter',
  /** Angebot */
  Offer = 'offer',
  /** Auftragsbestätigung */
  OfferConfirmation = 'offerConfirmation',
  /** Arbeitsanweisung */
  WorkInstructions = 'workInstructions',
  /** Anlieferung Packmaterial vorab */
  PackingMaterialDelivery = 'packingMaterialDelivery',
  /** Abholung Packmaterial */
  PackingMaterialPickup = 'packingMaterialPickup',
  /** Anschreiben Fragebogen */
  FeedbackLetter = 'feedbackLetter',
  /** Arbeitsschein */
  WorkSlip = 'workSlip',
  /** Rechnung */
  Invoice = 'invoice'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  username: Scalars['String'];
  fullName: Scalars['String'];
  signaturePrefix?: Maybe<Scalars['String']>;
};

export type CreateUserInput = {
  username: Scalars['String'];
  fullName: Scalars['String'];
  signaturePrefix?: Maybe<Scalars['String']>;
  password: Scalars['String'];
};

export type UpdateUserInput = {
  username: Scalars['String'];
  fullName: Scalars['String'];
  signaturePrefix?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};




export type GetCalculationParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalculationParametersQuery = (
  { __typename?: 'Query' }
  & { staffCategories: (
    { __typename?: 'StaffCategories' }
    & { consultant: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id' | 'hourlyRate' | 'dailyRate'>
    ), teamLeader: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id' | 'dailyRate' | 'hourlyRate'>
    ), carrier: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id' | 'dailyRate' | 'hourlyRate'>
    ), trainee: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id' | 'dailyRate' | 'hourlyRate'>
    ), temporaryEmployee: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id' | 'dailyRate' | 'hourlyRate'>
    ), glassPacker: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id' | 'dailyRate' | 'hourlyRate'>
    ) }
  ), calculationParameters: (
    { __typename?: 'CalculationParameters' }
    & Pick<CalculationParameters, 'storageRent' | 'containerRent' | 'containerHandling' | 'containerTransport' | 'noParkingZone' | 'bulkyWasteDisposal' | 'kilometerRatePackingMaterial' | 'trailerThreshold' | 'insuranceFactor' | 'insuranceMinimum' | 'truckToll' | 'truckTollWithTrailer'>
  ), vehicles: (
    { __typename?: 'Vehicles' }
    & { consultantCar: (
      { __typename?: 'Vehicle' }
      & Pick<Vehicle, 'id' | 'hourlyRate' | 'dailyRate' | 'kilometerRate'>
    ), furnitureTruck: (
      { __typename?: 'Vehicle' }
      & Pick<Vehicle, 'id' | 'hourlyRate' | 'dailyRate' | 'kilometerRate'>
    ), trailer: (
      { __typename?: 'Vehicle' }
      & Pick<Vehicle, 'id' | 'hourlyRate' | 'dailyRate' | 'kilometerRate'>
    ), lift: (
      { __typename?: 'Vehicle' }
      & Pick<Vehicle, 'id' | 'hourlyRate' | 'dailyRate' | 'kilometerRate'>
    ), staffCar: (
      { __typename?: 'Vehicle' }
      & Pick<Vehicle, 'id' | 'hourlyRate' | 'dailyRate' | 'kilometerRate'>
    ) }
  ) }
);

export type UpdateCalculationParametersMutationVariables = Exact<{
  calculationParameters: CalculationParametersInput;
  staffCategories: StaffCategoriesInput;
  vehicles: VehiclesInput;
}>;


export type UpdateCalculationParametersMutation = (
  { __typename?: 'Mutation' }
  & { updateCalculationParameters: (
    { __typename?: 'CalculationParameters' }
    & Pick<CalculationParameters, 'storageRent'>
  ), updateStaffCategories: (
    { __typename?: 'StaffCategories' }
    & { consultant: (
      { __typename?: 'StaffCategory' }
      & Pick<StaffCategory, 'id'>
    ) }
  ), updateVehicles: (
    { __typename?: 'Vehicles' }
    & { consultantCar: (
      { __typename?: 'Vehicle' }
      & Pick<Vehicle, 'id'>
    ) }
  ) }
);

export type ContractorFragmentFragment = (
  { __typename?: 'Contractor' }
  & Pick<Contractor, 'id' | 'name' | 'travelCost' | 'travelCostType' | 'hourlyRate' | 'workType'>
);

export type GetContractorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractorsQuery = (
  { __typename?: 'Query' }
  & { contractors: Array<(
    { __typename?: 'Contractor' }
    & ContractorFragmentFragment
  )> }
);

export type CreateContractorMutationVariables = Exact<{
  contractor: ContractorInput;
}>;


export type CreateContractorMutation = (
  { __typename?: 'Mutation' }
  & { createContractor: (
    { __typename?: 'Contractor' }
    & ContractorFragmentFragment
  ) }
);

export type UpdateContractorMutationVariables = Exact<{
  id: Scalars['ID'];
  contractor: ContractorInput;
}>;


export type UpdateContractorMutation = (
  { __typename?: 'Mutation' }
  & { updateContractor?: Maybe<(
    { __typename?: 'Contractor' }
    & ContractorFragmentFragment
  )> }
);

export type RemoveContractorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveContractorMutation = (
  { __typename?: 'Mutation' }
  & { removeContractor?: Maybe<(
    { __typename?: 'Contractor' }
    & Pick<Contractor, 'id'>
  )> }
);

export type FullInvoiceItemFragment = (
  { __typename?: 'InvoiceItem' }
  & Pick<InvoiceItem, 'id' | 'name' | 'unit' | 'price'>
);

export type GetInvoiceItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceItemsQuery = (
  { __typename?: 'Query' }
  & { invoiceItems: Array<(
    { __typename?: 'InvoiceItem' }
    & FullInvoiceItemFragment
  )> }
);

export type CreateInvoiceItemMutationVariables = Exact<{
  invoiceItem: InvoiceItemInput;
}>;


export type CreateInvoiceItemMutation = (
  { __typename?: 'Mutation' }
  & { createInvoiceItem: (
    { __typename?: 'InvoiceItem' }
    & FullInvoiceItemFragment
  ) }
);

export type UpdateInvoiceItemMutationVariables = Exact<{
  id: Scalars['ID'];
  invoiceItem: InvoiceItemInput;
}>;


export type UpdateInvoiceItemMutation = (
  { __typename?: 'Mutation' }
  & { updateInvoiceItem?: Maybe<(
    { __typename?: 'InvoiceItem' }
    & FullInvoiceItemFragment
  )> }
);

export type RemoveInvoiceItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveInvoiceItemMutation = (
  { __typename?: 'Mutation' }
  & { removeInvoiceItem?: Maybe<(
    { __typename?: 'InvoiceItem' }
    & Pick<InvoiceItem, 'id'>
  )> }
);

export type CreatePackingMaterialMutationVariables = Exact<{
  packingMaterial: PackingMaterialInput;
}>;


export type CreatePackingMaterialMutation = (
  { __typename?: 'Mutation' }
  & { createPackingMaterial: (
    { __typename?: 'PackingMaterial' }
    & Pick<PackingMaterial, 'id' | 'name' | 'price' | 'unit' | 'order'>
  ) }
);

export type UpdatePackingMaterialMutationVariables = Exact<{
  id: Scalars['ID'];
  packingMaterial: PackingMaterialInput;
}>;


export type UpdatePackingMaterialMutation = (
  { __typename?: 'Mutation' }
  & { updatePackingMaterial?: Maybe<(
    { __typename?: 'PackingMaterial' }
    & Pick<PackingMaterial, 'id' | 'name' | 'price' | 'unit' | 'order'>
  )> }
);

export type RemovePackingMaterialMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemovePackingMaterialMutation = (
  { __typename?: 'Mutation' }
  & { removePackingMaterial?: Maybe<(
    { __typename?: 'PackingMaterial' }
    & Pick<PackingMaterial, 'id'>
  )> }
);

export type UpdatePackingMaterialOrderMutationVariables = Exact<{
  order: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdatePackingMaterialOrderMutation = (
  { __typename?: 'Mutation' }
  & { updatePackingMaterialOrder: Array<(
    { __typename?: 'PackingMaterial' }
    & Pick<PackingMaterial, 'id' | 'name' | 'price' | 'unit' | 'order'>
  )> }
);

export type RoomFragmentFragment = (
  { __typename?: 'Room' }
  & Pick<Room, 'id' | 'name'>
  & { items: Array<(
    { __typename?: 'RoomItem' }
    & Pick<RoomItem, 'id' | 'name' | 'size' | 'assemblyTime' | 'disassemblyTime'>
    & { packingMaterial: Array<(
      { __typename?: 'RoomItemPackingMaterial' }
      & Pick<RoomItemPackingMaterial, 'amount' | 'inAdvance'>
      & { type: (
        { __typename?: 'PackingMaterial' }
        & Pick<PackingMaterial, 'id' | 'name' | 'unit'>
      ) }
    )> }
  )> }
);

export type GetRoomQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRoomQuery = (
  { __typename?: 'Query' }
  & { room?: Maybe<(
    { __typename?: 'Room' }
    & RoomFragmentFragment
  )> }
);

export type UpdateRoomMutationVariables = Exact<{
  id: Scalars['ID'];
  room: RoomInput;
}>;


export type UpdateRoomMutation = (
  { __typename?: 'Mutation' }
  & { updateRoom?: Maybe<(
    { __typename?: 'Room' }
    & RoomFragmentFragment
  )> }
);

export type RemoveRoomMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveRoomMutation = (
  { __typename?: 'Mutation' }
  & { removeRoom?: Maybe<(
    { __typename?: 'Room' }
    & Pick<Room, 'id'>
  )> }
);

export type GetRoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomsQuery = (
  { __typename?: 'Query' }
  & { rooms: Array<(
    { __typename?: 'Room' }
    & Pick<Room, 'id' | 'name'>
    & { items: Array<(
      { __typename?: 'RoomItem' }
      & Pick<RoomItem, 'id'>
    )> }
  )> }
);

export type CreateRoomMutationVariables = Exact<{
  room: RoomInput;
}>;


export type CreateRoomMutation = (
  { __typename?: 'Mutation' }
  & { createRoom: (
    { __typename?: 'Room' }
    & Pick<Room, 'id' | 'name'>
    & { items: Array<(
      { __typename?: 'RoomItem' }
      & Pick<RoomItem, 'id'>
    )> }
  ) }
);

export type GetPackingMaterialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPackingMaterialsQuery = (
  { __typename?: 'Query' }
  & { packingMaterials: Array<(
    { __typename?: 'PackingMaterial' }
    & Pick<PackingMaterial, 'id' | 'name' | 'price' | 'unit'>
  )> }
);

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = (
  { __typename?: 'Query' }
  & { templates: Array<(
    { __typename?: 'Template' }
    & Pick<Template, 'id' | 'type' | 'updatedAt'>
  )> }
);

export type UploadTemplateMutationVariables = Exact<{
  templateType: TemplateType;
  template: Scalars['Upload'];
}>;


export type UploadTemplateMutation = (
  { __typename?: 'Mutation' }
  & { uploadTemplate: (
    { __typename?: 'Template' }
    & Pick<Template, 'id' | 'type' | 'updatedAt'>
  ) }
);

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'username' | 'fullName' | 'signaturePrefix'>
  )> }
);

export type CreateUserMutationVariables = Exact<{
  user: CreateUserInput;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  user: UpdateUserInput;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
  )> }
);

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveUserMutation = (
  { __typename?: 'Mutation' }
  & { removeUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
  )> }
);

export const ContractorFragmentFragmentDoc: DocumentNode<ContractorFragmentFragment, unknown> = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contractor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"travelCost"}},{"kind":"Field","name":{"kind":"Name","value":"travelCostType"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"workType"}}]}}]};
export const FullInvoiceItemFragmentDoc: DocumentNode<FullInvoiceItemFragment, unknown> = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullInvoiceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]};
export const RoomFragmentFragmentDoc: DocumentNode<RoomFragmentFragment, unknown> = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"assemblyTime"}},{"kind":"Field","name":{"kind":"Name","value":"disassemblyTime"}},{"kind":"Field","name":{"kind":"Name","value":"packingMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inAdvance"}}]}}]}}]}}]};
export const GetCalculationParametersDocument: DocumentNode<GetCalculationParametersQuery, GetCalculationParametersQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalculationParameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consultant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamLeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"temporaryEmployee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"glassPacker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationParameters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storageRent"}},{"kind":"Field","name":{"kind":"Name","value":"containerRent"}},{"kind":"Field","name":{"kind":"Name","value":"containerHandling"}},{"kind":"Field","name":{"kind":"Name","value":"containerTransport"}},{"kind":"Field","name":{"kind":"Name","value":"noParkingZone"}},{"kind":"Field","name":{"kind":"Name","value":"bulkyWasteDisposal"}},{"kind":"Field","name":{"kind":"Name","value":"kilometerRatePackingMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"trailerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceFactor"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceMinimum"}},{"kind":"Field","name":{"kind":"Name","value":"truckToll"}},{"kind":"Field","name":{"kind":"Name","value":"truckTollWithTrailer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consultantCar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"kilometerRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"furnitureTruck"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"kilometerRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"kilometerRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"kilometerRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffCar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"dailyRate"}},{"kind":"Field","name":{"kind":"Name","value":"kilometerRate"}}]}}]}}]}}]};
export const UpdateCalculationParametersDocument: DocumentNode<UpdateCalculationParametersMutation, UpdateCalculationParametersMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCalculationParameters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationParameters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationParametersInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"staffCategories"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffCategoriesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicles"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VehiclesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCalculationParameters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationParameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationParameters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storageRent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateStaffCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"staffCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"staffCategories"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consultant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateVehicles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consultantCar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]};
export const GetContractorsDocument: DocumentNode<GetContractorsQuery, GetContractorsQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContractors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractorFragment"}}]}}]}},...ContractorFragmentFragmentDoc.definitions]};
export const CreateContractorDocument: DocumentNode<CreateContractorMutation, CreateContractorMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContractor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContractor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractorFragment"}}]}}]}},...ContractorFragmentFragmentDoc.definitions]};
export const UpdateContractorDocument: DocumentNode<UpdateContractorMutation, UpdateContractorMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContractor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractorFragment"}}]}}]}},...ContractorFragmentFragmentDoc.definitions]};
export const RemoveContractorDocument: DocumentNode<RemoveContractorMutation, RemoveContractorMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveContractor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeContractor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};
export const GetInvoiceItemsDocument: DocumentNode<GetInvoiceItemsQuery, GetInvoiceItemsQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoiceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullInvoiceItem"}}]}}]}},...FullInvoiceItemFragmentDoc.definitions]};
export const CreateInvoiceItemDocument: DocumentNode<CreateInvoiceItemMutation, CreateInvoiceItemMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInvoiceItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceItem"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInvoiceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceItem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceItem"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullInvoiceItem"}}]}}]}},...FullInvoiceItemFragmentDoc.definitions]};
export const UpdateInvoiceItemDocument: DocumentNode<UpdateInvoiceItemMutation, UpdateInvoiceItemMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInvoiceItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceItem"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInvoiceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoiceItem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceItem"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullInvoiceItem"}}]}}]}},...FullInvoiceItemFragmentDoc.definitions]};
export const RemoveInvoiceItemDocument: DocumentNode<RemoveInvoiceItemMutation, RemoveInvoiceItemMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveInvoiceItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeInvoiceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};
export const CreatePackingMaterialDocument: DocumentNode<CreatePackingMaterialMutation, CreatePackingMaterialMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePackingMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packingMaterial"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackingMaterialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPackingMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"packingMaterial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packingMaterial"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]};
export const UpdatePackingMaterialDocument: DocumentNode<UpdatePackingMaterialMutation, UpdatePackingMaterialMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePackingMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packingMaterial"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackingMaterialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePackingMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"packingMaterial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packingMaterial"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]};
export const RemovePackingMaterialDocument: DocumentNode<RemovePackingMaterialMutation, RemovePackingMaterialMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePackingMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePackingMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};
export const UpdatePackingMaterialOrderDocument: DocumentNode<UpdatePackingMaterialOrderMutation, UpdatePackingMaterialOrderMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePackingMaterialOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePackingMaterialOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]};
export const GetRoomDocument: DocumentNode<GetRoomQuery, GetRoomQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomFragment"}}]}}]}},...RoomFragmentFragmentDoc.definitions]};
export const UpdateRoomDocument: DocumentNode<UpdateRoomMutation, UpdateRoomMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"room"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"room"},"value":{"kind":"Variable","name":{"kind":"Name","value":"room"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomFragment"}}]}}]}},...RoomFragmentFragmentDoc.definitions]};
export const RemoveRoomDocument: DocumentNode<RemoveRoomMutation, RemoveRoomMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};
export const GetRoomsDocument: DocumentNode<GetRoomsQuery, GetRoomsQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]};
export const CreateRoomDocument: DocumentNode<CreateRoomMutation, CreateRoomMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"room"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoomInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"room"},"value":{"kind":"Variable","name":{"kind":"Name","value":"room"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]};
export const GetPackingMaterialsDocument: DocumentNode<GetPackingMaterialsQuery, GetPackingMaterialsQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPackingMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packingMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]};
export const GetTemplatesDocument: DocumentNode<GetTemplatesQuery, GetTemplatesQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]};
export const UploadTemplateDocument: DocumentNode<UploadTemplateMutation, UploadTemplateMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}}},{"kind":"Argument","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]};
export const GetUsersDocument: DocumentNode<GetUsersQuery, GetUsersQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"signaturePrefix"}}]}}]}}]};
export const CreateUserDocument: DocumentNode<CreateUserMutation, CreateUserMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};
export const UpdateUserDocument: DocumentNode<UpdateUserMutation, UpdateUserMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};
export const RemoveUserDocument: DocumentNode<RemoveUserMutation, RemoveUserMutationVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]};